// @flow
// import camelCase from 'lodash/camelCase';
import _ from 'lodash';

export default class StringUtils {
  static getPercentageDisplayLabel(amount: number) {
    if (!_.isNumber(amount)) {
      return 'Error';
    }

    switch (amount) {
      case 0:
        return 'No cost';
      case 100:
        return 'Full price';
      default:
        return `${amount}%`;
    }
  }

  static capitalize(str: string) {
    return str.split(' ').map(word => (
      word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
    )).join(' ');
  }
}
